module.exports = __webpack_public_path__ + "img/term-of-use.69d2ef68.png";